import { render, staticRenderFns } from "./AModalPreinscritos.vue?vue&type=template&id=5fbeddc2"
import script from "./AModalPreinscritos.vue?vue&type=script&lang=js"
export * from "./AModalPreinscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports